import React from "react";
import Button from "@mui/material/Button";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ModalAllder from "components/layout/ModalAllder";

export default function ConfirmPaymentModal({
  modal,
  setModal,
  pendingCount = 0,
  onConfirm,
  saving = false,
}) {
  return (
    <ModalAllder
      modal={modal}
      setModal={setModal}
      htitle="ยืนยันการรับชำระเงิน"
      hbtn={false}
    >
      <div className="text-center py-4">
        <WarningAmberIcon sx={{ fontSize: 80, color: "#FF6B00" }} />
        <div
          className="mt-3 text-lg font-semibold"
          style={{ color: "#2F4858" }}
        >
          ยืนยันการรับชำระเงิน
        </div>
        <div
          className="mt-2 text-sm"
          style={{ color: "rgba(76,78,100,0.68)" }}
        >
          มีรายการที่รอยืนยัน {pendingCount} รายการ
        </div>
        <div
          className="mt-1 text-sm"
          style={{ color: "rgba(76,78,100,0.68)" }}
        >
          คุณต้องการบันทึกการชำระเงินทั้งหมดหรือไม่?
        </div>
      </div>
      <div className="flex justify-center gap-3 pt-4 pb-4">
        <Button
          variant="outlined"
          color="gray"
          disabled={saving}
          onClick={() => setModal((prev) => ({ ...prev, open: false }))}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={saving}
          onClick={onConfirm}
        >
          ยืนยัน
        </Button>
      </div>
    </ModalAllder>
  );
}
